import React, { Component } from "react";
import Lottie from "react-lottie";

export default class ArrowAnimation extends Component {
  render() {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: require("../assets/images/arrowAnimation.json"),
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };

    return <Lottie options={defaultOptions} height={"40px"} width={"40px"} />;
  }
}
